import React from 'react';
import styled from 'styled-components';
import { HeaderSm } from './header-sm';
import { DataUnavailableMsg } from './kpi-styles';

const DataUnavailableHeaderWrapper = styled.div`
  height: 61px;
  margin-bottom: 15px;
`;

/**
 *
 * @param {string} props.label Name of dataset type whose data is unavailable
 */
export function DataUnavailableHeader({ label, type }) {
  return (
    <DataUnavailableHeaderWrapper>
      <HeaderSm noData type={type} label={label}>
        <DataUnavailableMsg />
      </HeaderSm>
    </DataUnavailableHeaderWrapper>
  );
}
